import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import _kebabCase from "lodash/kebabCase";

import {
  getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { A as CallToActionA } from "components/CallToAction";

const Item = styled.li`
  background-color: ${p => p.theme.colors.barelyGrey};
  display: flex;
  flex-direction: column;
  height: 408px;
  list-style: none;
  margin: 22px auto;
  padding: 0;
  width: 294px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    height: 551px;
    width: 400px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    margin: 30px auto;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    display: inline-block;
  }
`;

const ItemImage = styled.div`
  background-image: url(${p => p.image});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 237px;
  min-width: 100%;
  @media screen and (min-width: ${getSize("mobile480")}) {
    height: 320px;
  }
`;

const Content = styled.div`
  display: flex;
  height: 170px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-grow: 1;
  padding: 18px 22px 22px 22px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    height: 230px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    padding: 24px 30px 30px 30px;
  }
`;

const Title = styled.h3`
  color: ${p => p.theme.colors.blueGrey};
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0.9px;
  margin: 0;
  padding: 0;
  text-align: left;
  text-transform: uppercase;
  ${getFontFamily("medium")}
`;

export const ResourceItem = props => {
  const { backgroundContent, file, image, title } = props;
  return (
    <Item>
      {image ? <ItemImage image={image} /> : backgroundContent}
      <Content>
        <Title>{title}</Title>
        <CallToActionA href={file} download={_kebabCase(title)}>
          Download
        </CallToActionA>
      </Content>
    </Item>
  );
};

ResourceItem.propTypes = {
  backgroundContent: PropTypes.node,
  file: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
};
